import { resolve, ImResponse, storeHomeClient } from '.';

export function list() {
  return resolve(storeHomeClient.get<ImResponse<General.Trigger[]>>('/admin/users/self/triggers'));
}

export interface CreateBody {
  trigger: General.Trigger;
}

export function create(body: CreateBody) {
  return resolve(storeHomeClient.post('/admin/users/self/triggers', body));
}
